import { useState, useEffect } from 'react';
import { Select } from 'antd';

// Zustand store
import { useShallow } from 'zustand/react/shallow';
import { useContractsStore } from 'storeZustand';

const SelectCompanyType = () => {
	const [selectedCompanyType, setSelectedCompanyType] = useState(null);

	// Договоры клиента
	const [
		addFilter,
		filters
	] = useContractsStore(useShallow((state) => [
		state.addFilter,
		state.filters
	]));

	// Сброс типа компании
	useEffect(() => {
		if (Object.keys(filters).length === 0) {
			setSelectedCompanyType(null);
		}
	}, [filters]);

	const handleCompanyTypeFetch = async (value) => {
		setSelectedCompanyType(value);

		const filters = {
			company_type: value
		};

		addFilter(filters);
	};

	return (
		<Select
			placeholder="Тип компании"
			style={{ width: '100%' }}
			allowClear
			value={selectedCompanyType || undefined}
			onChange={handleCompanyTypeFetch}
			options={[
				{
					value: 'Собственная',
					label: 'Собственная'
				},
				{
					value: 'Внешняя',
					label: 'Внешняя'
				}
			]}
		/>
	)
}

export default SelectCompanyType;